import {AuthProvider} from "../contexts/AuthContext";
import {Outlet} from "react-router-dom";
import {LicenseProvider} from "../contexts/LicenseProvider";

const RoleLayout = () => {
    return (
        <AuthProvider>
            <LicenseProvider>
                <Outlet />
            </LicenseProvider>
        </AuthProvider>
    );
};

export default RoleLayout;